<template>
  <span class="price-wrap">
    <span ref="price" class="price" :class="{ 'price-zero': price == 0 }">
      <template v-if="price > 0 || !showFreeText">
        <span class="rmb-svg-new" v-html="svg"></span>
        <span>
          <span>{{ privatePrice }}</span>
          <template v-if="priceDecimal > 0">
            <span class="decimal">.{{ priceDecimal }}</span>
          </template>
        </span>
      </template>
      <template v-else>免费</template>
    </span>
    <strike ref="strike" class="price-underline" v-if="priceUnderline > 0">
      <span class="rmb-svg-new" v-html="svg"></span>
      <span>{{ privateUnderlinePrice }}</span>
      <template v-if="underlinePriceDecimal > 0">
        <span class="decimal">.{{ underlinePriceDecimal }}</span>
      </template>
    </strike>
  </span>
</template>
<script>
export default {
  name: 'CurrencyNew',
  props: {
    price: {
      type: Number,
      default: 0,
    },
    priceUnderline: {
      type: Number,
      default: 0,
    },
    isUnderlineLeft: {
      type: Boolean,
      default: true,
    },
    priceTwo: {
      type: Boolean,
      default: false,
    },
    underlinePriceTwo: {
      type: Boolean,
      default: false,
    },
    showFreeText: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    svg() {
      return this.$store.state.svg || '¥';
    },
    privatePrice() {
      if (this.priceTwo) {
        let array = (this.price / 100).toString().split('.');
        return array[0] || '';
      } else {
        return this.getFloatPrice(this.price);
      }
    },
    priceDecimal() {
      if (this.priceTwo) {
        let array = (this.price / 100).toString().split('.');
        return this.getPrice(array[1]);
      } else {
        return '';
      }
    },
    privateUnderlinePrice() {
      if (this.underlinePriceTwo) {
        let array = (this.priceUnderline / 100).toString().split('.');
        return array[0] || '';
      } else {
        return this.getFloatPrice(this.priceUnderline);
      }
    },
    underlinePriceDecimal() {
      if (this.underlinePriceTwo) {
        let array = (this.priceUnderline / 100).toString().split('.');
        return this.getPrice(array[1]);
      } else {
        return '';
      }
    },
  },
  data() {
    return {
      // privatePrice: "",
      // priceDecimal: "",
      // privateUnderlinePrice: "",
      // underlinePriceDecimal: ""
    };
  },
  created() {
    // if (this.priceTwo) {
    //   let array = (this.price / 100).toString().split(".");
    //   this.privatePrice = array[0];
    //   this.priceDecimal = array[1] || "";
    // } else {
    //   this.privatePrice = this.price / 100;
    // }
    // if (this.underlinePriceTwo) {
    //   let array = (this.priceUnderline / 100).toString().split(".");
    //   this.privateUnderlinePrice = array[0];
    //   this.underlinePriceDecimal = array[1] || "";
    // } else {
    //   this.privateUnderlinePrice = this.priceUnderline / 100;
    // }
  },
  methods: {
    //如果价格除以100，小数位超过两位则保留两位小数
    getFloatPrice(price) {
      let newPrice = price / 100;
      //判断除以100后的价格是不是小数
      if ((price / 100).toString().indexOf('.') != -1) {
        let num = (price / 100).toString().split('.')[1].length;
        if (num >= 2) {
          newPrice = (price / 100).toFixed(2); //如果小数位数大于2，则保留两位小数
        } else {
          newPrice = price / 100;
        }
      } else {
        newPrice = price / 100;
      }
      return newPrice;
    },
    getPrice(price) {
      let newPrice = price;
      //当大于两位小数
      if (price && price.length > 2) {
        //四舍五入，保留两位小数
        let num = (this.price / 100).toFixed(2);
        newPrice = num.toString().split('.')[1];
      }
      return newPrice || '';
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.isUnderlineLeft && this.$refs.strike) {
        this.$refs.price.before(this.$refs.strike);
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.price-wrap {
  display: flex;
  justify-content: flex-end;
}
.price {
  line-height: 1;
  font-size: 17px;
  font-weight: 500;
  color: #ff2d28;
  display: flex;
  position: relative;
  top: 1px;
  align-items: flex-end;
  .rmb-svg-new {
    font-size: 14px;
    position: relative;
    top: -1px;
  }
  .decimal {
    font-size: 14px !important;
    line-height: 1;
  }
  &.price-zero {
    font-size: 16px;
  }
}
.price-underline {
  line-height: 1;
  font-size: 14px;
  color: #999999;
  display: flex;
  align-items: flex-end;
}
</style>
<style lang="scss">
.rmb-svg-new {
  width: auto;
  height: auto;
}
.rmb-svg-new svg,
.rmb-svg-new g,
.rmb-svg-new path {
  fill: currentColor !important;
  height: 0.9em;
  width: auto;
  width: 0.7em;
}
</style>
